module.exports = __webpack_public_path__ + "img/Icon-Staff.0ee1a5be.svg";